import { DEFAULT_CURRENCY } from './currencies';
import { getDefaultVideoDealInfo } from './video-deal-info';
export const getDefaultVodSettings = function (currency) {
  if (currency === void 0) {
    currency = DEFAULT_CURRENCY;
  }
  return {
    allowDownload: false,
    currency,
    memberOnly: false,
    dealInfo: getDefaultVideoDealInfo(currency)
  };
};
//# sourceMappingURL=default-vod-settings.js.map